import type { ComponentProps } from 'react';
import { DatePicker } from 'antd';
import enUS from 'antd/locale/en_US';
import plPL from 'antd/locale/pl_PL';
import 'dayjs/locale/en';
import 'dayjs/locale/pl';

const POLISH_LANGUAGE_PREFIX = 'pl';
const DEFAULT_BROWSER_LANGUAGE = 'en-US';
const SECONDS_FORMAT_SUFFIX = ':ss';

const browserLanguage = (): string =>
  typeof navigator === 'undefined' ? DEFAULT_BROWSER_LANGUAGE : navigator.language;

export const resolveDatePickerLocalization = (language = browserLanguage()) => {
  const locale = language.toLowerCase().startsWith(POLISH_LANGUAGE_PREFIX)
    ? plPL
    : enUS;
  const dateTimeFormat =
    locale.DatePicker?.lang.dateTimeFormat?.replace(SECONDS_FORMAT_SUFFIX, '') ??
    enUS.DatePicker?.lang.dateTimeFormat?.replace(SECONDS_FORMAT_SUFFIX, '');

  return {
    dateTimeFormat,
    locale,
  };
};

export const BROWSER_DATE_PICKER_LOCALIZATION = resolveDatePickerLocalization();

type DatePickerProps = ComponentProps<typeof DatePicker>;
type RangePickerProps = ComponentProps<typeof DatePicker.RangePicker>;

export const LocalizedDatePicker = (props: DatePickerProps): JSX.Element => (
  <DatePicker
    {...props}
    locale={BROWSER_DATE_PICKER_LOCALIZATION.locale.DatePicker}
  />
);

export const LocalizedRangePicker = (props: RangePickerProps): JSX.Element => (
  <DatePicker.RangePicker
    {...props}
    locale={BROWSER_DATE_PICKER_LOCALIZATION.locale.DatePicker}
  />
);
